// "Lembrar neste navegador": a API devolve um token aleatório válido por 7 dias depois de um 2FA
// confirmado. Ele fica no localStorage, por e-mail, e é enviado no login para dispensar o código.
// Limpar os dados do navegador (ou passar os 7 dias) faz o código voltar a ser pedido.
const CHAVE = "va-2fa-dispositivos";

const chaveEmail = email => String(email || "").trim().toLowerCase();

const ler = () => {
  try {
    return JSON.parse(window.localStorage.getItem(CHAVE) || "{}") || {};
  } catch (e) {
    return {};
  }
};

const gravar = dados => {
  try {
    window.localStorage.setItem(CHAVE, JSON.stringify(dados));
  } catch (e) {
    // sem localStorage: o código volta a ser pedido em todo login
  }
};

export const obterDispositivo2fa = email => {
  const item = ler()[chaveEmail(email)];
  if (!item || !item.token) return null;
  if (item.expira && new Date(item.expira) <= new Date()) {
    removerDispositivo2fa(email);
    return null;
  }
  return item.token;
};

export const salvarDispositivo2fa = (email, token, expira) => {
  if (!token) return;
  gravar({ ...ler(), [chaveEmail(email)]: { token, expira } });
};

export const removerDispositivo2fa = email => {
  const dados = ler();
  delete dados[chaveEmail(email)];
  gravar(dados);
};

export const removerTodosDispositivos2fa = () => gravar({});
